<template>
  <div
    class="formkit-inner formkit-disabled:bg-black-100 formkit-disabled:dark:bg-primary-1000 formkit-disabled:cursor-not-allowed formkit-disabled:pointer-events-none flex items-center ring-1 bg-white dark:bg-primary-1000 ring-black/20 dark:ring-white/20 focus-within:ring-primary focus-within:ring-2 [&>label:first-child]:focus-within:text-primary rounded mb-1"
  >
    <input
      v-if="context.type !== 'textarea'"
      v-model="model"
      v-maska
      :data-maska="context.mask"
      data-maska-tokens="{
      '#': { 'pattern': '[0-9]' },
      '@': { 'pattern': '[A-Za-zА-Яа-яЁё]' },
      '*': { 'pattern': '[A-Za-zА-Яа-яЁё0-9]' }
      }"
      :type="context.type"
      class="formkit-input appearance-none bg-transparent dark:text-black rounded autoFillInputLightModeOverride dark:autoFillInputDarkModeOverride focus:outline-none focus:ring-0 focus:shadow-none w-full px-3 py-3 border-none text-base text-black-700 dark:text-white placeholder-black-300"
      :placeholder="context.placeholder ?? 'Введите текст'"
      :disabled="passed"
    />
  </div>
</template>

<script setup>
import { vMaska } from 'maska/vue'
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  context: {
    type: Object,
  },
  type: {
    type: Object,
  },
  passed: {
    type: Boolean,
  },
})

const emits = defineEmits(['passed', 'update:model-value'])

const model = computed({
  get: () => {
    return props.modelValue
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})
</script>
